import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import apiCalls from '../utils/apiCalls';
import utils from '../utils/utils';
import Loader from '../components/loader';
import ErrorMessage from '../components/errorMessage';
import { Link, withRouter } from 'react-router-dom';
import DATE_FORMAT from '../components/constants/dateFormat';

const MarketplaceAdminDeliveryDayIndividual = ({ deliveryDayMarketplaceId }) => {
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    setOrders([]);
    setLoading(true);
    setError(null);
    apiCalls
      .getOrders({
        deliveryDayMarketplaceId: deliveryDayMarketplaceId,
      })
      .then((result) => {
        if (result.data && result.data.orders) {
          setOrders(result.data.orders);
          setLoading(false);
        }
      })
      .catch((errors) => {
        setError(utils.getErrorMessageFromResponse(errors));
        setLoading(false);
      });
  }, []);

  const { formatMessage } = useIntl();

  return (
    <div className="row">
      <div className="col-12 col-lg-10">
        <Loader show={loading} />
        <ErrorMessage error={error} />

        <table className="table table-striped marketplace-admin__table">
          <thead>
            <tr>
              <th scope="col">
                <FormattedMessage id={'marketplace.admin.delivery.day.orders.individual.table.order.id'} />
              </th>
              <th scope="col">
                <FormattedMessage id={'marketplace.admin.delivery.day.orders.individual.table.items'} />
              </th>
              <th scope="col">
                <FormattedMessage id={'marketplace.admin.delivery.day.orders.individual.table.total.sum'} />
              </th>
              <th scope="col">
                <FormattedMessage id={'marketplace.admin.delivery.day.orders.individual.table.date.created'} />
              </th>
            </tr>
          </thead>
          <tbody>
            {orders.map((order, itemIndex) => {
              const dateCreated = utils.getDateFromString(order.dateCreated).format(DATE_FORMAT.displayWithTime);
              const avatar = (
                <img
                  className="rounded-circle m-r-1"
                  src={order.user.avatar.thumbnailImage}
                  alt={order.user.screenName + ' avatar'}
                />
              );

              return (
                <tr key={itemIndex}>
                  <td>
                    {avatar} #{order.batchId} - {order.user.screenName}
                  </td>
                  <td>
                    {order.items.map((orderItem, index) => (
                      <div>
                        {utils.getItemName(orderItem.item, formatMessage)} x {orderItem.quantity}
                      </div>
                    ))}
                  </td>
                  <td>{order.totalSum}€</td>
                  <td>{dateCreated}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

MarketplaceAdminDeliveryDayIndividual.propTypes = {
  deliveryDayMarketplaceId: PropTypes.number.isRequired,
};

MarketplaceAdminDeliveryDayIndividual.defaultProps = {};

export default withRouter(MarketplaceAdminDeliveryDayIndividual);
